<template>
  <div>
    <p
      v-if="!hideLabel && labelPosition === 'top'"
      :class="['col-12', 'text-primary', ...[].concat(labelStyles)]"
      style="font-size: 16px; margin: 0 0 5px"
    >
      Lease term
    </p>
    <div v-if="isActive" class="row q-col-gutter-sm" :class="{ 'lease-term-options__row--stretch': fullWidthButtons }">
      <span
        v-if="!hideLabel && labelPosition === 'left'"
        :class="['text-primary', ...[].concat(labelStyles)]"
        style="font-size: 16px; margin: 8px 12px 0px"
      >
        Lease term
      </span>
      <CheckboxButton
        v-for="(leaseTermOption, index) in leaseTerms"
        :key="index"
        :label="leaseTermOption.label"
        v-model="selected[leaseTermOption.value]"
        @input="emitSelected(leaseTermOption)"
        :disabled="selected[leaseTermOption.value]"
        outlined
        :rounded="fullWidthButtons"
        :full-width="fullWidthButtons"
        removeOpacity
      />
    </div>
    <div v-else class="row q-col-gutter-sm">
      <CheckboxButton
        v-for="(leaseTerm, index) in leaseTerms"
        :key="index"
        :label="leaseTerm.label"
        @input="emitSelected(leaseTerm)"
        :disabled="true"
        outlined
        removeOpacity
      />
    </div>
  </div>
</template>
<script>
import CheckboxButton from './CheckboxButton';

export default {
  props: {
    value: {
      default: () => {}
    },
    isActive: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'top'
    },
    labelStyles: {
      type: [String, Array],
      default: () => ['text-weight-bolder']
    },
    options: {
      type: Array,
      default: () => []
    },
    /** Hide the built-in "Lease term" label (e.g. when the parent supplies a section title). */
    hideLabel: {
      type: Boolean,
      default: false
    },
    /** Equal-width toggles (e.g. mobile filter drawer). */
    fullWidthButtons: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: {},
      leaseTerms: this.options
    };
  },
  watch: {
    value: {
      handler(v) {
        if (!v || v.value == null) return;
        const next = {};
        this.leaseTerms.forEach((opt) => {
          next[opt.value] = opt.value === v.value;
        });
        this.selected = next;
      },
      immediate: true,
      deep: true
    },
    options: {
      handler(opts) {
        this.leaseTerms = opts;
        if (!this.value || this.value.value == null) return;
        const next = {};
        this.leaseTerms.forEach((opt) => {
          next[opt.value] = opt.value === this.value.value;
        });
        this.selected = next;
      },
      immediate: true
    }
  },
  methods: {
    emitSelected(leaseTerm) {
      const next = {};
      this.leaseTerms.forEach((opt) => {
        next[opt.value] = opt.value === leaseTerm.value;
      });
      this.selected = next;
      this.$emit('input', leaseTerm);
    }
  },
  components: {
    CheckboxButton
  }
};
</script>

<style lang="sass" scoped>
.lease-term-options__row--stretch
  flex-wrap: nowrap
  .checkbox-button
    flex: 1
    min-width: 0
</style>
